import { useLocation } from "react-router-dom";
import styles from "./CheclistReport.module.css";
import { Col, Row } from "antd";
// import { IoCheckmarkCircleSharp } from 'react-icons/io5';
import { BsCheckCircle, BsFillCheckCircleFill } from 'react-icons/bs';
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import moment from "moment";
const ChecklistReport = () => {
  const { state } = useLocation();
  const data = state?.reportData;
  console.log("data", data);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    getLanguage();
  }, [])

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };


  return (
    <div className={styles.ChecklistReport_mainCon}>
      <div className={styles.ChecklistReport_heading}>
        <h1>{t("Checklist Report")}</h1>
      </div>
      <Row className={styles.ChecklistReport_row}>
        <Col className={styles.ChecklistReport_colLeft}>
          <div className={styles.ChecklistReport_colLeftOne}>
            <span className={styles.ChecklistReport_num}>{data?.total_items}</span>
            <p className={styles.ChecklistReport_jobs}>{t("Items total")}</p>
          </div>
          <div className={styles.ChecklistReport_colLeftTwo}>
            <span className={styles.ChecklistReport_num}>{data?.items_done}</span>
            <p className={styles.ChecklistReport_jobs}>{t("Items done")}</p>
          </div>
          <div className={styles.ChecklistReport_colLeftThree}>
            <span className={styles.ChecklistReport_num}>{data?.items_not_done}</span>
            <p className={styles.ChecklistReport_jobs}>{t("Items not done")}</p>
          </div>
        </Col>
        <Col className={styles.ChecklistReport_colRight}>
          <div className={styles.ChecklistReport_dataDiv}>
            <div className={styles.ChecklistReport_subDataDiv}>
              <div className={styles.ChecklistReport_dataDivRow}>
                <div className={styles.FirstCol}>
                  <span>{t("Checklist")}</span>
                  <p>{data?.name}</p>
                </div>
                <div className={styles.SecondCol}>
                  <span>{t("Item")}</span>
                  <p>{data?.items?.length}</p>
                </div>
                <div className={styles.SecondCol}>
                  <span>%{t("Done")}</span>
                  <p>{data?.completed_percent}</p>
                </div>
              </div>
              <div className={styles.ChecklistReport_dataDivRow}>
                <div className={styles.FirstCol}>
                  <span>{t("Completed by")}</span>
                  <p>{data?.completed_by}</p>
                </div>
                <div className={styles.SecondCol}>
                  <span>{t("Date")}</span>
                  <p>{data?.date ? moment(data?.date).format('MM-DD-YYYY') : ''}</p>
                </div>
                <div className={styles.SecondCol}>
                  <span>{t("Location")}</span>
                  <p>{data?.job_location?.address}</p>
                </div>
              </div>
            </div>
          </div>
          <h3>{t("Items")}</h3>

          <div className={styles.ChecklistReport_items}>
            <div className={styles.ChecklistReport_SubItems}>
              <h2>{t('Regular Cleaning')}</h2>
              {data?.items?.map((item, index) => {
                console.log('item', item)
                return (
                  <div className={styles.ChecklistReport_itemList}>
                    <p>{item?.name}</p>
                    {item?.is_completed == 1 ? <BsFillCheckCircleFill color="#4DCC39" className={styles.ChecklistReport_icon} />
                      :
                      <BsCheckCircle color="#F44336" className={styles.ChecklistReport_icon} />}
                    {/* <BsFillCheckCirclesFill color="#4DCC39" className={styles.ChecklistReport_icon} /> */}
                  </div>
                )
              })}
              {/* <div className={styles.ChecklistReport_itemList}>
                    <p>Mop</p>
                    <BsCheckCircle color="#F44336" className={styles.ChecklistReport_icon} />
                  </div>
                  <div className={styles.ChecklistReport_itemList}>
                    <p>Mop</p>
                    <BsCheckCircle color="#F44336" className={styles.ChecklistReport_icon} />
                  </div> */}
            </div>
          </div>

        </Col>
      </Row>
    </div>
  );
};
export default ChecklistReport;
